export default {
  value: -1,
  label: 'Unlimited'
};